import CustomSelect2 from '../../customSelect2/CustomSelect2';
import './dateInputs.css';

const date = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' }
];

const month = [
  { value: 'jan', label: 'Jan' },
  { value: 'feb', label: 'Feb' },
  { value: 'march', label: 'March' },
  { value: 'april', label: 'April' },
  { value: 'may', label: 'May' }
];

const year = [
  { value: '2003', label: '2003' },
  { value: '2004', label: '2004' }
];

function DateInputs() {
  return (
    <div className="dateOfBirth">
      <div>
        <CustomSelect2 placeholder="DD" options={date} />
      </div>
      <div>
        <CustomSelect2 placeholder="MM" options={month} />
      </div>
      <div>
        <CustomSelect2 placeholder="YYYY" options={year} />
      </div>
    </div>
  );
}

export default DateInputs;
